import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "List",
  "use": "List-usage",
  "viewBox": "0 0 28 16",
  "content": "<symbol viewBox=\"0 0 28 16\" id=\"List\">\n  <path fill=\"currentColor\" d=\"M0 9.6h3.2V6.4H0v3.2zM0 16h3.2v-3.2H0V16zM0 3.2h3.2V0H0v3.2zm6.4 6.4h22.4V6.4H6.4v3.2zm0 6.4h22.4v-3.2H6.4V16zm0-16v3.2h22.4V0H6.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol